import { ProductLogo, UsernameDisplay } from "@gx1/gx-npm-ui";
import { Fragment } from "react";
import { InitUserTeam, NotificationDiscussionSource, UserNotificationType } from "../../../../../app.constants";
import { UserDiscussionNotification } from "../../../../../app.types";
import { CommentIcon } from "./notification-comment.icon";
import { MentionIcon } from "./notification-mention.icon";
import { MultiCommentAvatarIcon } from "./notification-multi-comment-avatar.icon";
import styles from "./notification-discussion-avatar.styles.module.scss";
import classnames from "classnames";

type NotificationDiscussionAvatarComponentProps = {
  notification: UserDiscussionNotification;
};

export const NotificationDiscussionAvatarComponent = ({ notification }: NotificationDiscussionAvatarComponentProps) => {
  const renderMultiCommentAvatar = () => (
    <Fragment>
      <MultiCommentAvatarIcon className={styles.avatar} />
      <div
        className={classnames(
          styles.avatarBadgeWrapper,
          styles.multiComment,
          "avatarBadgeWrapper" /* targeted by parent for onHover */
        )}
      >
        <CommentIcon className={styles.avatarBadgeIcon} />
      </div>
    </Fragment>
  );

  const renderSingleCommentContent = () => {
    if (
      notification.discussionCommentUserTeam === InitUserTeam.SURVEY_RECIPIENT &&
      notification.initUserTeam === InitUserTeam.EVALUATOR &&
      notification.discussionSource === NotificationDiscussionSource.QUESTIONNAIRE_CROSS_TEAM) {
      return (
        <ProductLogo
          imageWidth="24px"
          imageHeight="24px"
          logo={notification.initProductImageLoc}
        />);
    } else {
      return (
        <Fragment>
          <UsernameDisplay
            rootClassName={styles.avatar}
            isSmallerIcon
            showName={false}
            name={notification.discussionCommentByUsers[0]}
          />
          <div
            className={classnames(styles.avatarBadgeWrapper, "avatarBadgeWrapper" /* targeted by parent for onHover */)}
          >
            {notification.notificationType === UserNotificationType.DISCUSSION_ACTIVITY &&
              <CommentIcon className={styles.avatarBadgeIcon} />
            }
            {notification.notificationType === UserNotificationType.DISCUSSION_COMMENT_MENTION &&
              <MentionIcon className={styles.avatarBadgeIcon} />
            }
          </div>
        </Fragment>
      );
    }
  };

  return (
    <div className={styles.root}>
      {
        notification.discussionCommentByUsers.length === 1
          ? renderSingleCommentContent()
          : renderMultiCommentAvatar()
      }
    </div>
  );
};
